import BaseExcelService from './BaseExcelService';

class TherapyExcelService extends BaseExcelService {
  getBaseUrl() {
    return '~/api/excel/therapy';
  }
}

export default new TherapyExcelService();
